import { FeatureFlagKey } from "@redotech/feature-flags-model";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { createContext, memo, type ReactNode } from "react";

let cachedFlag: boolean | null = null;
let flagPromise: Promise<boolean> | null = null;

const InChatEscalationContext = createContext<boolean | undefined>(undefined);

export function useInChatEscalationFlag(): boolean {
  return useRequiredContext(InChatEscalationContext);
}

export const InChatEscalationFlagProvider = memo(
  function InChatEscalationFlagProvider({ children }: { children: ReactNode }) {
    const platformRpcClient = useRequiredContext(
      RedoPlatformAuthRpcClientContext,
    );

    const flagLoad = useLoad(async () => {
      if (cachedFlag !== null) {
        return cachedFlag;
      }
      if (flagPromise === null) {
        flagPromise = platformRpcClient
          .getFeatureFlag({
            flagKey: FeatureFlagKey.NEW_MERCHANT_CHAT_ESCALATION,
          })
          .then((response) => {
            cachedFlag = response.enabled;
            return response.enabled;
          })
          .catch((error) => {
            flagPromise = null;
            throw error;
          });
      }
      return flagPromise;
    }, []);

    return (
      <InChatEscalationContext.Provider value={flagLoad.value ?? false}>
        {children}
      </InChatEscalationContext.Provider>
    );
  },
);
